import type { FaireProductEntity } from "../../entity_types/product";

export const p_7q5aqm48ty: FaireProductEntity = {
  token: "p_7q5aqm48ty",
  type: "product",
  name: "Surprise Bath Bomb | Unicorn",
  brandToken: "b_2j1b52vu",
  brandName: "garb2ART",
  imageUrl:
    "https://cdn.faire.com/fastly/eeed5536fce914c811a8ff5135aaaaecf63834c0973a78c5e50217da8d50d5a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3232de936a3c0a39a181705c29818184d2b0201a87a4a14b913cc946adacbc3d.jpeg",
    "https://cdn.faire.com/fastly/53f279d73059452003ecfc2d802069443b9bb0679640cc39adfd8dd433fcc44a.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "There's a toy in every bath! Each of our Surprise Bath Bombs is hand-pressed with Epsom salt, shea butter, and natural ingredients.\n\n• Use under adult supervision - toys can be a choking hazard\n• Toy scents and colors will vary\n• Packaged in a resealable bag as pictured",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:16.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
